export function useUserPurchaseStatus () {
  const user = useUser()
  const { list: certifications } = useCertifications()

  const hasPurchased = certifications?.some(certification => user.accessTo(certification.id, 'EXAM'))
  const hasPurchasedExamOnly = computed(() => {
    return !certifications?.some(certification => user.accessTo(certification.id, 'TRAINING'))
  })

  return {
    hasPurchased,
    hasPurchasedExamOnly,
    isGuest: user.isGuest
  }
}
